var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.newFlag),expression:"newFlag"}],staticClass:"newtime"},[_c('div',{staticClass:"newtimer"},[_vm._v(_vm._s(_vm.timerFlag ? _vm.descending[_vm.lang] : _vm.ascending[_vm.lang]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }